import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, UserPlus, Info } from 'lucide-react';
import './Hero.css';
import API_BASE_URL from '../../../config/api';

const Hero = () => {
  const [banners, setBanners] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/herobanner`);
        if (response.ok) {
          const data = await response.json();
          setBanners(data || []);
        }
      } catch (error) {
        console.error('Error fetching banners:', error);
      }
    };

    fetchBanners();
  }, []);

  // Auto-play com controle de transição
  useEffect(() => {
    if (banners.length === 0) return;

    const interval = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % (banners.length + 1));
        setIsTransitioning(false);
      }, 300);
    }, 6000);

    return () => clearInterval(interval);
  }, [banners.length]);

  const goToSlide = (index) => {
    if (isTransitioning || index === currentIndex) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex(index);
      setIsTransitioning(false);
    }, 300);
  };

  const nextSlide = () => {
    goToSlide((currentIndex + 1) % (banners.length + 1));
  };

  const prevSlide = () => {
    goToSlide((currentIndex - 1 + banners.length + 1) % (banners.length + 1));
  };

  const totalSlides = banners.length + 1; // Hero + banners
  const isHeroSlide = currentIndex === 0;

  return (
    <section className="home-hero">
      {/* Background Decor */}
      <div className="hero-decor hero-decor-1"></div>
      <div className="hero-decor hero-decor-2"></div>

      {/* Slide 0: Hero Original */}
      {isHeroSlide && (
        <div className="home-hero-slide home-hero-default">
          <div className="container home-hero-content">
            <div className="home-hero-text">
              <h1 className="animate-in" style={{ '--delay': '0.1s' }}>
                Clube Desportivo <br /> <span className="text-secondary">Da Póvoa</span>
              </h1>
              <p className="subtitle animate-in" style={{ '--delay': '0.2s' }}>
                Tradição, Paixão e Excelência no Desporto
              </p>
              <p className="description animate-in" style={{ '--delay': '0.3s' }}>
                Unidos pelo amor ao desporto e dedicados à formação de atletas e à construção de uma comunidade forte.
              </p>
              <div className="home-hero-buttons animate-in" style={{ '--delay': '0.4s' }}>
                <a href="/registo" className="btn-hero-primary">
                  <UserPlus size={18} /> Tornar-se Sócio
                </a>
                <a href="/clube" className="btn-hero-outline">
                  <Info size={18} /> O Clube
                </a>
              </div>
            </div>
            <div className="home-hero-image animate-in" style={{ '--delay': '0.5s' }}>
              <img src="/CDP_logo.png" alt="Emblema CDP" className="home-hero-emblem" />
            </div>
          </div>
        </div>
      )}

      {/* Slides 1+: Imagens dos Banners */}
      {!isHeroSlide && banners[currentIndex - 1] && (
        <div className="home-hero-slide home-hero-banner">
          <img
            src={`${API_BASE_URL}${banners[currentIndex - 1].imageUrl}`}
            alt={`Banner ${currentIndex}`}
            className="home-hero-banner-image"
          />
          <div className="banner-overlay"></div>
        </div>
      )}

      {/* Setas - aparecem APENAS quando há banners */}
      {banners.length > 0 && (
        <>
          <button className="home-hero-nav prev glass-nav" onClick={prevSlide} aria-label="Anterior">
            <ChevronLeft size={24} />
          </button>
          <button className="home-hero-nav next glass-nav" onClick={nextSlide} aria-label="Próximo">
            <ChevronRight size={24} />
          </button>

          {/* Dots */}
          <div className="home-hero-dots">
            {Array.from({ length: totalSlides }).map((_, index) => (
              <button
                key={index}
                className={`home-hero-dot ${index === currentIndex ? 'active' : ''}`}
                onClick={() => setCurrentIndex(index)}
                aria-label={`Ir para slide ${index + 1}`}
              />
            ))}
          </div>
        </>
      )}

      {/* Wave */}
      <div className="wave-bottom">
        <svg viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path
            fill="var(--ice-white)"
            fillOpacity="1"
            d="M0,224L80,213.3C160,203,320,181,480,181.3C640,181,800,203,960,213.3C1120,224,1280,224,1360,224L1440,224L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
          ></path>
        </svg>
      </div>
    </section>
  );
};

export default Hero;